function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 3C8 4.65685 6.65685 6 5 6C3.34315 6 2 4.65685 2 3C2 1.34315 3.34315 0 5 0C6.65685 0 8 1.34315 8 3ZM12.5 6C13.8807 6 15 4.88071 15 3.5C15 2.11929 13.8807 1 12.5 1C11.1193 1 10 2.11929 10 3.5C10 4.88071 11.1193 6 12.5 6ZM0 9.5C0 8.67157 0.671573 8 1.5 8H8.5C9.32843 8 10 8.67157 10 9.5V11C10 11 10 14.5 5 14.5C0 14.5 0 11 0 11V9.5ZM11.8674 12.0101C11.7991 12.2967 11.6933 12.6363 11.5283 13H12.9999C14.6567 13 15.9999 11.6569 15.9999 10V9.5C15.9999 8.67157 15.3283 8 14.4999 8H11.6631C11.879 8.45463 11.9999 8.9632 11.9999 9.5V11.0298L11.9992 11.0561C11.9987 11.0786 11.9978 11.1048 11.9964 11.1344C11.9936 11.1937 11.9886 11.2674 11.9798 11.3534C11.9623 11.5248 11.9294 11.7494 11.8674 12.0101Z",
  fill: "black",
  fillOpacity: 0.38
});

function SvgPerson3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson3);
export default __webpack_public_path__ + "static/media/person_3.4381ad8d.svg";
export { ForwardRef as ReactComponent };